import React, { useState, useEffect, useContext } from 'react'
import SideBarLayout from '../layouts/SideBarLayout'
import SideBarLayout1 from '../layouts/SideBarLayout1'
import SideBarLayout2 from '../layouts/SideBarLayout2'
import Modal from '../components/Modal'
import { useLocation, useNavigate } from 'react-router-dom'
import HomeInput from '../components/formik/HomeInput'
import * as Yup from 'yup'
import { Formik } from 'formik'
import NavCard from '../components/NavCard'
import { faAdd, faClose, faDiagramProject, faMapLocationDot, faPlusSquare, faStickyNote, faUserGroup, faUserCircle, faPlugCircleBolt, faHouseFloodWaterCircleArrowRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AppTextArea from '../components/formik/AppTextArea'
import Button from '../components/Button'
import BowtieListItem from '../components/BowtieListItem'
import SearchBar from '../components/SearchBar'
import SideNavItem from '../components/SideNavItem'
import AppContext from '../contexts/AppContext';
import instance from '../api/client'
import authService from '../authentication'
import Loader from '../components/loaders/Loader'
import { toast } from 'react-toastify'
import HomeSubmit from '../components/formik/HomeSubmit'
import IconButton from '../components/IconButton'
import ModelItem from '../components/ModelItem'
import AppInput from '../components/formik/AppInput'

const validationSchema = Yup.object().shape({
  name: Yup.string().required().label("DIagram Name"),
});

export default function BowtieList() {
  const location = useLocation()
  const { state } = location
  const [disabled, setDisabled] = useState(true)
  const [showProjectInfo, setShowProjectInfo] = useState(false)
  const [loading, setLoading] = useState(true)
  const [showCreationForm, setshowCreationForm] = useState(false)
  const [diagrams, setDiagrams] = useState([])
  const [searchText, setSearchText] = useState('')
  const [editDisabled, setEditDisabled] = useState(false)
  const navigate = useNavigate();
  const { user, openModal, setNavHeaderText } = useContext(AppContext)

  useEffect(() => {
    getDiagrams()
  }, [])

  console.log('state: btl', state);

  const createDiagram = async (name) => {
    setLoading(true)
    try {
      const { data, status } = await instance.post(`/bowtie/new-diagram/${state?.project.code}`, { diagramName: name }, {
        headers: {
          Authorization: `Bearer ${authService.getCurrentUser()}`
        }
      })
      if (status == 200) {
        console.log(data);
        setDiagrams(data)
        setLoading(false)
        return { data, status }
      } else {
        toast.error(`Error: ${status}`, {
          position: toast.POSITION.TOP_CENTER
        });
        return { data, status }
      }
    } catch (error) {
      toast.error(`Error: ${error}`, {
        position: toast.POSITION.TOP_CENTER
      });
      return error
    }
  }
  
  const getDiagrams = async () => {
    setLoading(true)
    try {
      const { data, status } = await instance.get(`/bowtie/all-diagrams/${location.state.project.code}`, {
        headers: {
          Authorization: `Bearer ${authService.getCurrentUser()}`
        }
      })
      if (status == 200) {
        console.log(data);
        setDiagrams(data)
        setLoading(false)
      } else {
        toast.error(`Error: ${status}`, {
          position: toast.POSITION.TOP_CENTER
        });
      }
    } catch (error) {
      toast.error(`Error: ${error}`, {
        position: toast.POSITION.TOP_CENTER
      });
    }
  }

  const deleteDiagram = async (diagramId) => {
    setLoading(true)
    console.log({ diagramId });
    try {
      const { data, status } = await instance.post(`/bowtie/delete-diagram/${location.state.project.code}`, { diagramId }, {
        headers: {
          Authorization: `Bearer ${authService.getCurrentUser()}`
        }
      })
      if (status == 200) {
        toast.info(`Deleted: ${diagramId}`, {
          position: toast.POSITION.TOP_CENTER
        });
        setDiagrams(diagrams.filter((diagram) => diagram.diagramId != diagramId))
        setLoading(false)
      } else {
        toast.error(`Error: ${status}`, {
          position: toast.POSITION.TOP_CENTER
        });
      }
    } catch (error) {
      toast.error(`Error: ${error}`, {
        position: toast.POSITION.TOP_CENTER
      });
    }
    setLoading(false)
  }

  const onSubmit = async (form, { resetForm }) => {
    let exists = false
    diagrams.forEach((diagram) => {
      if (diagram.name == form.name) {
        exists = true
      }
    })
    if (exists) {
      toast.info(`Diagram name already exists`, {
        position: toast.POSITION.TOP_CENTER
      });
    } else {
      setLoading(true)
      const { data, status } = await createDiagram(form.name)
      setLoading(false)
      if (status == 200) {
        toast.info(`New diagram created`, {
          position: toast.POSITION.TOP_CENTER
        });
        navigate('/project', { state: { diagram: data, project: state.project } })
      } else {
        toast.error(`An error eccured`, {
          position: toast.POSITION.TOP_CENTER
        });
      }
    }
  }

  const searchByName = (searchText, items) => {
    const filteredItems = items?.filter((item) => {
      if (item['diagramName']?.toLowerCase().search(searchText.toLowerCase()) != -1) {
        return true
      } else {
        return false
      }
    })

    console.log('rite:', filteredItems);
    return filteredItems
  }

  useEffect(() => {
    setNavHeaderText('Risk Analysis: Diagram List')
  }, [])

  const onInfoUpdate = () => { }

  return (
    <SideBarLayout2 title={'Diagrams'}>
      <div className="flex-1 bg-gray-100 shadow-lg mx-5 px-5 pt-5 rounded">
        <div className='grid grid-cols-6 gap-2'>
          <div className='col-span-4 p-10 h-[80vh] overflow-y-scroll'>
            <div className='flex items-center justify-between pl-2'>
              <SearchBar value={searchText} onChange={(e) => setSearchText(e.target?.value)} />
              {diagrams?.length ? <IconButton onClick={() => navigate('/prioritization-interface', { state })} icon={faPlugCircleBolt} title={'Prioritization'} /> : ''}
              {diagrams?.length ? <IconButton onClick={() => navigate('/mitigation-effects-simulation', { state })} icon={faPlugCircleBolt} title={'Simulation'} /> : ''}
              {
                showCreationForm || showProjectInfo ?
                  <div onClick={() => { setshowCreationForm(false); setNavHeaderText('Risk Analysis: Diagram List'); setShowProjectInfo(false) }} className='h-8 w-8 flex cursor-pointer justify-center items-center rounded-lg border-2 border-gray-300 hover:text-white hover:bg-gray-700'>
                    <FontAwesomeIcon icon={faClose} size='1x' />
                  </div>
                  :
                  <IconButton onClick={() => setshowCreationForm(true)} icon={faPlusSquare} title={'New Diagram'} />
              }
            </div>

            <div className='flex-col overflow-y-scroll'>
              {
                !loading && !diagrams?.length && !showCreationForm && !showProjectInfo && <div className='w-full text-center'>No diagrams</div>
              }
              {!loading ?
                (!showCreationForm && !showProjectInfo ?
                  searchByName(searchText, diagrams)?.map((diagram) => (
                    <BowtieListItem onDelete={() => {
                      openModal("Delete Diagram?",
                        `Are you sure you want to delete diagram "${diagram.diagramName}"`,
                        () => { deleteDiagram(diagram.diagramId) }
                      )
                    }}
                      title={diagram.diagramName} creator={diagram.createdBy}
                      lastModifiedAt={`${diagram.lastModifiedAt[2]}-${diagram.lastModifiedAt[1]}-${diagram.lastModifiedAt[0]}`}
                      createdAt={`${diagram.createdAt[2]}-${diagram.createdAt[1]}-${diagram.createdAt[0]}`}
                      onClick={() => { navigate('/project', { state: { diagram, project: location.state.project } }) }} />
                  ))
                  :
                  !showProjectInfo ?
                    <Formik
                      initialValues={{ name: '' }}
                      validationSchema={validationSchema}
                      onSubmit={onSubmit}
                    >
                      <>
                        <div className='mx-32 bg-white px-20 py-10 shadow-lg rounded-lg border-2 border-gray-300'>
                          <div class="my-6 w-full">
                            <HomeInput name={'name'} label={'diagram name'} placeholder={'My Diagram'} type={'text'} />
                          </div>
                          <div className='mt-10'>
                            <HomeSubmit text={'Create'} />
                          </div>
                        </div>
                      </>
                    </Formik>
                    :
                    (
                      <div className='w-full p-4 bg-white mx-5 rounded-lg h-[80vh] overflow-y-scroll'>
                        <div className='flex justify-between p-2 border-b-2 border-slate-300 h-14 rounded-t-lg'>
                          <div className='flex font-dmsans items-center'>
                            <svg fill="none" viewBox="0 0 24 24" height="28" width="28" className='rounded-full border-2 border-slate-300 p-1 mr-1'>
                              <path fill="currentColor" d="M2 8a1 1 0 011-1h18a1 1 0 110 2H3a1 1 0 01-1-1zM2 12a1 1 0 011-1h18a1 1 0 110 2H3a1 1 0 01-1-1zM3 15a1 1 0 100 2h12a1 1 0 100-2H3z" />
                            </svg>
                            <div className='flex flex-col'>
                              <span className='text-md font-semibold'>Project Info</span>
                            </div>
                          </div>
                        </div>



                        <Formik
                          initialValues={{ name: state?.project.name, code: state?.project.code, description: state?.project.description }}
                          validationSchema={validationSchema}
                          onSubmit={onInfoUpdate}
                        >
                          <>
                            <div className='m-2 border-2 border-slate-300 rounded-lg p-4'>
                              <div>Date created - {location.state?.project.createdAt[0]}-{location.state?.project.createdAt[1]}-{location.state?.project.createdAt[2]}</div>
                              <div style={{fontFamily: 'Roboto'}}>
                              <AppInput boxClassName={'w-full '} disabled={true} name={'code'} inputclassName={'font-dmsans'} placeholder={'AB12'} label={'Code'} labelclassName={'font-dmsans'} type={'text'} />
                              <AppInput boxClassName={'w-full '} disabled={disabled} name={'name'} placeholder={'New Project'} label={'Name'} labelclassName={'font-dmsans'} type={'text'} />
                              </div>
                            </div>

                            <div className='m-2 border-2 border-slate-300 rounded-lg p-4'>

                              <div className='flex font-dmsans items-center border-b-2 pb-1'>
                                <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} viewBox="0 0 24 24" height="26" width="26">
                                  <path stroke="none" d="M0 0h24v24H0z" />
                                  <path d="M14 3v4a1 1 0 001 1h4" />
                                  <path d="M17 21H7a2 2 0 01-2-2V5a2 2 0 012-2h7l5 5v11a2 2 0 01-2 2zM9 17h6M9 13h6" />
                                </svg>

                                <span className='text-sm font-semibold'>Description</span>
                              </div>
                              <div style={{ fontFamily: 'RobotoCondensed' }}>
                                <AppTextArea unedittable={disabled} rows={8} name={'description'} placeholder={'Say something about this project'} label={'Project Description'} />
                              </div>
                            </div>
                          </>
                        </Formik>
                        {/* <div className='flex'>
                          <Button disabled={editDisabled} className={' flex bg-blue-500 text-white mt-20 font-dmsans'} onClick={() => { setDisabled(false); setEditDisabled(true) }} >
                            <svg viewBox="0 0 1024 1024" fill="currentColor" height="26" width="26" className='mr-1'>
                              <path d="M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z" />
                            </svg>
                            Edit
                          </Button>
                          <Button className={'flex bg-green-500 text-white ml-10 mt-20 font-dmsans'} onClick={() => { setEditDisabled(false); setDisabled(true) }} >
                            <svg fill="none" viewBox="0 0 15 15" height="26" width="26" className='mr-1'>
                              <path fill="currentColor" fillRule="evenodd" d="M1.903 7.297c0 3.044 2.207 5.118 4.686 5.547a.521.521 0 11-.178 1.027C3.5 13.367.861 10.913.861 7.297c0-1.537.699-2.745 1.515-3.663.585-.658 1.254-1.193 1.792-1.602H2.532a.5.5 0 010-1h3a.5.5 0 01.5.5v3a.5.5 0 01-1 0V2.686l-.001.002c-.572.43-1.27.957-1.875 1.638-.715.804-1.253 1.776-1.253 2.97zm11.108.406c0-3.012-2.16-5.073-4.607-5.533a.521.521 0 11.192-1.024c2.874.54 5.457 2.98 5.457 6.557 0 1.537-.699 2.744-1.515 3.663-.585.658-1.254 1.193-1.792 1.602h1.636a.5.5 0 110 1h-3a.5.5 0 01-.5-.5v-3a.5.5 0 111 0v1.845h.002c.571-.432 1.27-.958 1.874-1.64.715-.803 1.253-1.775 1.253-2.97z" clipRule="evenodd" />
                            </svg>
                            Update
                          </Button>
                        </div> */}

                      </div>
                    )
                )
                :
                <div style={{}} className='flex items-center justify-center'>
                  <div className=' flex-1 items-center bg-white justify-center h-[68vh] pt-20'>
                    <Loader animationName={'list'} width={'100%'} />
                  </div>
                </div>
              }
            </div>
          </div>
          <div className='col-span-2 gap-6 flex flex-col mt-10 mx-2 h-[80vh] overflow-y-scroll'>
            <div onClick={() => {
              if (showProjectInfo) {
                setNavHeaderText('Risk Analysis: Diagram List');
                return setShowProjectInfo(false)
              }
              setNavHeaderText('Risk Analysis: Project Info')
              setShowProjectInfo(true)
            }} className={`${showProjectInfo ? 'shadow-md shadow-teal-600 text-teal-700' : ''} cursor-pointer p-4 border-b-2 border-slate-300 flex flex-col bg-white rounded-lg`}>
              <div className='flex'>
                <p className='font-dmsans text-lg font-bold'>Project Overview</p>
              </div>
              <div className='mt-2'>
                <p className='font-dmsans text-2xl font-extrabold truncate'>{state.project.name}</p>
                <p style={{fontFamily: 'Roboto'}} className='font-dmsans text-slate-500 text-sm mt-2 truncate'>{state.project.description}</p>
              </div>
              <div className='my-3 flex flex-col'>

                <div className='flex w-[80%] justify-between items-center mx-2 text-slate-700'>
                  <p style={{fontFamily: 'Roboto'}} className='font-light font-dmsans text-sm flex items-center mr-2'>
                    <FontAwesomeIcon icon={faHouseFloodWaterCircleArrowRight} className='text-slate-500 mr-1' size='md' />
                    Schema
                  </p>

                  <p style={{fontFamily: 'RobotoCondensed'}} className=' text-sm truncate'>
                    {state.project.schemaName}
                  </p>
                </div>

                <div className='flex w-[80%] justify-between items-center mx-2 text-slate-700'>
                  <p style={{fontFamily: 'Roboto'}} className='font-light font-dmsans text-sm flex items-center'>
                    <FontAwesomeIcon icon={faUserCircle} className='text-slate-500 mr-2' size='md' />
                    Creator
                  </p>

                  <p style={{fontFamily: 'RobotoCondensed'}} className='truncate text-sm '>
                    {state.project.creator}
                  </p>
                </div>

                <div className='flex w-[80%] justify-between items-center mx-2 text-slate-700'>

                  <p style={{fontFamily: 'Roboto'}} className='font-light font-dmsans text-sm flex'>
                    <svg className='mr-2 mt-0.5' fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} viewBox="0 0 24 24" height="1em" width="1em">
                      <path d="M22 12 A10 10 0 0 1 12 22 A10 10 0 0 1 2 12 A10 10 0 0 1 22 12 z" />
                      <path d="M12 6v6l4 2" />
                    </svg>
                    Created at
                  </p>

                  <p style={{fontFamily: 'RobotoCondensed'}} className='truncate text-sm '>
                    {state.project.createdAt[2]}-{state.project.createdAt[1]}-{state.project.createdAt[0]}
                  </p>

                </div>
              </div>
            </div>

            <div className='w-full flex gap-2'>
              <NavCard className={' bg-theme/80 hover:bg-theme'} onClick={() => {
                setNavHeaderText('Risk Analysis: Collaborators');
                navigate('/project-info/colabs', { state })
              }} icon={faUserGroup} title={'Collaborators'} />
            </div>

            <ModelItem alt model={{ name: state.project.schemaName, id: null, schema: state.project.schema }} />

          </div>
        </div>
      </div>
    </SideBarLayout2>
  )
}
